import React from 'react';
import { BrowserRouter, Routes, Route, } from "react-router-dom";
import Homepage from '../HomePage/HomePage'
import BlogPage from '../BlogPage/BlogPage';
import BlogDetails from '../BlogDetails/BlogDetails';
import AboutPage from '../AboutPage/AboutPage';
import ContactPage from '../ContactPage/ContactPage';
// import TokenPage from '../TokenPage/TokenPage';
import SigninPage from '../SigninPage/SigninPage';
import SignupPage from '../SignupPage/SignupPage';
import TermsService from '../TermsService/TermsService';
import PrivacyPolicy from '../PrivacyPolicy/PrivacyPolicy';
import CookiePolicy from '../CookiePolicy/CookiePolicy';
import FaqPage from '../Faq/Faq';
import Blockchain from '../Blockchain/Blockchain';
import Disclaimer from '../Disclaimer/disclaimer';
import TopCoinUKWallets from '../TopCoinUKWallets/TopCoinUKWallets';
import TopCoinPolicy from '../TopCoinPolicy/TopCoinPolicy';
import EternityCoin from '../EternityCoin/EternityCoin';
import RewardOptions from '../Mywallet/RewardOptions';
import TopCoinUKBanyUnit from '../TopCoinUKBanyUnit/TopCoinUKBanyUnit';
import TopCoinUKTax from '../TopCoinUKTax/TopCoinUKTax';
import TUCKCustomerUnit from '../TUCKCustomerUnit/TUCKCustomerUnit';
import YoungEarners from '../YoungEarners/YoungEarners';


const AllRoute = () => {

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="young-earners-under-18" element={<YoungEarners />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="topcoin-policy" element={ <TopCoinPolicy />} />
          <Route path="eternitycoin" element={ <EternityCoin/> } />
          <Route path="terms-conditions" element={ <TermsService />} />
          <Route path="limit-policy" element={ <TermsService />} />
          <Route path="cookie-policy" element={<CookiePolicy />} />
          <Route path="tuck-units" element={<RewardOptions />} />
          <Route path="blog" element={<BlogPage />} />
          <Route path="blog-single/:slug" element={<BlogDetails />} />   
          <Route path="customer-unit" element={<TUCKCustomerUnit />} />     
          <Route path="baby-unit" element={<TopCoinUKBanyUnit />} />
          <Route path="tax-info" element={ <TopCoinUKTax />} />
          <Route path="contact" element={<ContactPage />} />
          <Route path="blockchain" element={<Blockchain />} />
          <Route path="about" element={<AboutPage />} />   
          <Route path="disclaimer" element={<Disclaimer />} />   
          <Route path="faq" element={<FaqPage />} />  
          <Route path="wallets" element={<TopCoinUKWallets />} />   
          <Route path="sign_in" element={<SigninPage />} />
          <Route path="sign_up" element={<SignupPage />} />
        </Routes>
      </BrowserRouter>

    </div>
  );
}

export default AllRoute;
